/**
 *
 * Form Controller
 *
 * It finally occurred to me that there should be a form class for handling similar functions
 * that happen in all forms
 */

/**
 *
 * Used In:
 *
 * -partner-ui.js
 *
 *
 */

const $         = require( 'jQuery' );
const _model    = require( './_model.js' );
require( './_attribution-workflow.js' );
const _LStorage = require( './_LStorage' );
const tob       = require('./_tob-metrics')
const _ = require('lodash')
const submitFormToGoogleSheets = require("./submitFormToGoogleSheets");
const ChiliPiperMetrics = require("./ChiliPiperMetrics");
const ReturningUser = require("./ReturningUser");
const CtaAfterSubmission = require("./CtaAfterSubmission");
const {isDevelopment} = require("./Env");

new ReturningUser();

const ctaAfterSubmission = new CtaAfterSubmission();

const FormController = (function () {

  var proto = {};

  proto.event__PreventDefault = function (event) {
    event.preventDefault();
    return false;
  };

  proto.event__keyCodeFn = function (keycodes, callbackFn) {

    let map = {};

    if (typeof keycodes == 'undefined' || !Array.isArray(keycodes)) {

      return;
    }

    //convert keycodes to obj
    map = Object.assign(...keycodes.map(k => ({[k]: false})));

    try {

      $(document).keydown(function (e) {
        if (e.keyCode in map) {
          map[e.keyCode] = true;
          if (Object.values(map).every(val => val)) {

            if (typeof callbackFn === 'function') callbackFn();

          }
        }
      }).keyup(function (e) {
        if (e.keyCode in map) {
          map[e.keyCode] = false;
        }
      });
    } catch (e) {
      console.log(`Error with creating keyCodeFN: ${keycodes}`);

    }


  };

  proto.event__deckBackDoor = function (deckable, deck) {

    var map = {67: false, 79: false, 78: false, 70: false};


    if (typeof deckable == 'undefined' || typeof deck == 'undefined') {

      console.log(`Error with params ${deckable}  or ${deck}`);
      return;
    }

    try {

      $(document).keydown(function (e) {
        if (e.keyCode in map) {
          map[e.keyCode] = true;
          if (map[67] && map[79] && map[78] && map[70]) {

            deckable.goToDeck(deck);

          }
        }
      }).keyup(function (e) {
        if (e.keyCode in map) {
          map[e.keyCode] = false;
        }
      });
    } catch (e) {
      //
    }


  };


  /**
   * @param _APIState {any}
   * @param alwaysShowChiliPiper {boolean}
   * @param options {undefined | {
   *     chiliPiperRoute: string,
   *     chiliPiperTitle: undefined|string,
   *     chiliPiperFormId: undefined|string,
   *     chiliPiperFormQuery: string,
   *     formType: undefined | "Marketo",
   * }}
   * @param $form {undefined | jQuery}
   * @return {Promise<void>}
   */
  proto.marketo__submit = function (
    _APIState,
    alwaysShowChiliPiper = false,
    options,
    $form
  ) {
    if (_.has(_APIState, 'Email') && window.heap) {
      try {
        window.heap.identify(_APIState['Email']);
      } catch (e) {
        console.error("Heap did not work!");
      }
    }


    options = _.assign(
      {
        chiliPiperRouter: "inbound-router",
        chiliPiperTitle: undefined,
        chiliPiperFormId: undefined,
        formType: "Marketo",
      },
      options
    );

    const APIState = {}

    for (var x in _APIState) {
      if (x === 'iterable/encrypted/Marketing_Channels__c' || typeof _APIState[x] !== 'string') {
        APIState[x] = _APIState[x]
      } else {
        APIState[x] = _APIState[x] || '';
      }

      APIState[x] = _.trimEnd(APIState[x], "; ");
    }

    if (
      (APIState.formid === "1122" || APIState.formid === "1159") &&
      !_.has(APIState, "Marketing_Channels__c")
    ) {
      APIState["Marketing_Channels__c"] = '';
    }

    const silentBlockedEmailDomains = _.split(
      JSON.parse(atob(window.ITBL.silent_blocked_email_domains || ""))
    );

    const shouldBlockSilently = _.some(
      silentBlockedEmailDomains,
      domain => !!domain && _.endsWith(_.get(APIState, "Email"), domain)
    );

    return new Promise((resolve, reject) => {
      if (!window.MktoForms2) {
        reject(new Error('MktoForms2 is not defined'));
        return;
      }

      APIState.Locale__c = ($('html').attr('lang') || '').toLowerCase()
      APIState.Locale__c = APIState.Locale__c.split('-')[0]
      if (!['en', 'en-gb', 'es', 'fr', 'de', 'nl'].includes(APIState.Locale__c)) {
        APIState.Locale__c = ''
      }

      const munchkinCookie = APIState._mkt_trk

      // Munckin script hack! It is important inside of the referral form that
      // this field is an empty string
      const isReferralForm = $('#form-deckable2__referral-form').length > 0;
      if(isReferralForm) {
        APIState._mkt_trk = '';
      }

      const marketoBaseUrl = 'https://go.iterable.com';
      const { formid, munchkinId } = APIState;

      APIState.marketingConsent = APIState.marketingConsent === 'true'
        ? 'true'
        : 'NULL'

      const hasPartnerMarketingOptIn = Object.prototype.hasOwnProperty.call(
        APIState,
        'partnerMarketingOptIn'
      )

      if (hasPartnerMarketingOptIn) {
        APIState.partnerMarketingOptIn = APIState.partnerMarketingOptIn === 'true'
          ? 'true'
          : 'NULL'
      }

      if ($form) {
        const $countries = $form.find('[name="Country"]').find('option');
        const countries = [];
        for (let country of $countries) {
          countries.push($(country).val());
        }

        if (!_.isEmpty(countries)) {
          const hqCountry = _.get(APIState, 'HQ_Country__c');
          const hqState = _.get(APIState, 'HQ_State__c');

          if (
              !_.some(countries, hqCountry) ||
              !_.some(
                  _.get(
                      _.find(countries, { name: hqCountry }),
                      'states'
                  ),
                  hqState
              )
          ) {
            APIState.HQ_State__c = '';
          }
        }
      }

      if (!['anonymous@iterable.com', 'anoymous@iterable.com'].includes(APIState.Email) && APIState.formid !== '1262') {
        ctaAfterSubmission.saveFormData(APIState);
        for (let x in APIState) {
          _LStorage.encrypted__set(`iterable/encrypted/${x}`, APIState[x]);
        }
      }

      const sendEmail = subject => {
        APIState.wp_email_message = JSON.stringify(APIState, null, 4);

        const message = APIState.wp_email_message

        _model.model__handleEmailSubmission(subject, message)
      }

      const emailSubject = `Form: ${_.findKey(window.ITBL.itbl_marketo, x => x == formid)}, Email: ${APIState.Email}, Form ID: ${formid}`

      sendEmail(`Form Submission => ${emailSubject}`);

      const googleSheetData = {
        'JSON Payload': JSON.stringify(APIState, null, 2),
        Email: APIState.Email,
        FirstName: APIState.FirstName,
        LastName: APIState.LastName,
        Company: APIState.Company,
        Company_Size_Range__c: APIState.Company_Size_Range__c,
        Country: APIState.Country,
        State: APIState.State,
        marketingConsent: APIState.marketingConsent,
        URL: window.location.href,
        _mktoReferrer: APIState._mktoReferrer,
        formVid: APIState.formVid,
        munchkinId: APIState.munchkinId,
        _mkt_trk: APIState._mkt_trk,
        HQ_Country__c: APIState.HQ_Country__c,
        HQ_State__c: APIState.HQ_State__c,
        Marketing_Channels__c: APIState.Marketing_Channels__c,
        Email_Sends_per_Month_Range__c: APIState.Email_Sends_per_Month_Range__c,
        demoRequestNotesImport: APIState.demoRequestNotesImport,
        demoRequestEmailProvider: APIState.demoRequestEmailProvider,
        Phone: APIState.Phone,
        Email_Verification_Status__c: APIState.Email_Verification_Status__c,
        kickboxReason: APIState.kickboxReason,
        Locale__c: APIState.Locale__c,
        Primary_Use_Case__c: APIState.Primary_Use_Case__c,
        formid: APIState.formid,
        LOG_TYPE: "RECAPTCHA_CHALLENGE",
    };

      submitFormToGoogleSheets({
        ...googleSheetData,
        LOG_TYPE: "SUBMISSION_SUBMIT_BUTTON_CLICK"
      });

      if (shouldBlockSilently) {
        resolve();
        return;
      }

      window.MktoForms2.loadForm(
        marketoBaseUrl,
        munchkinId,
        formid,
        form => {
          const mktoStyleLoaded = document.querySelectorAll('#mktoStyleLoaded');
          if (mktoStyleLoaded.length > 1) {
            for (let i = 0; i < mktoStyleLoaded.length; i++) {
              mktoStyleLoaded[i].remove();
            }
          }

          form.vals(APIState);
          form.addHiddenFields(APIState);

          form.onValidate(valid => {
            if (!valid) {
              submitFormToGoogleSheets({
                ...googleSheetData,
                LOG_TYPE: "SUBMISSION_VALIDATION_ERROR",
              });
              sendEmail(`Form Submission Failure => ${emailSubject}`);

              for(let key in window.localStorage) {
                if (key.startsWith('iterable/encrypted')) {
                  localStorage.removeItem(key);
                }
              }

              localStorage.removeItem("CtaAfterSubmissionFormData");

              reject(new Error('Marketo form validation failed.'));
            }
          });

          form.onSuccess(() => {
            if (formid === '1122' || formid === "1159") {
              document.dispatchEvent(new Event('itbl.demo_form_submit'));
            } else {
              document.dispatchEvent(
                new CustomEvent('itbl.marketo_submit', { detail: { formId: formid } })
              );
            }

            submitFormToGoogleSheets({
              ...googleSheetData,
              LOG_TYPE: "SUBMISSION_SENT_TO_MARKETO"
            });

            let isKickboxVerified = false;

            if (APIState.Email_Verification_Status__c) {
              isKickboxVerified = APIState.Email_Verification_Status__c && (
                APIState.Email_Verification_Status__c === "deliverable" ||
                (APIState.Email_Verification_Status__c === "risky" && APIState.kickboxReason === "low_deliverability") ||
                (APIState.Email_Verification_Status__c === "unknown" && ["no_connect", "timeout", "invalid_smtp", "unavailable_smtp", "unexpected_error"].includes(APIState.kickboxReason))
              );
            }

            const utmShowChiliPiper = (
              APIState.UTM_Source__c === "li" &&
              APIState.UTM_Medium__c === "p-social"
            );

            const showChiliPiper = (
              alwaysShowChiliPiper || (
                window.ITBL.chilipiper_enabled &&
                _.includes(["1122", "1159"], formid) &&
                window.ChiliPiper &&
                (isKickboxVerified || utmShowChiliPiper)
              )
            );

            if (showChiliPiper) {
              // Overrides 1122 form IDs. This hack is used for embedded Setka
              // forms.
              const $formidInput = $('form input[name="formid"][value="1122"]');
              const formtype = $formidInput.closest('form').data('formtype');

              $formidInput.closest('form').attr('id', formtype);

              const args = { map: true };

              if (options.chiliPiperTitle) {
                _.set(args, "title", options.chiliPiperTitle);
              }

              if (options.chiliPiperFormId) {
                _.set(args, "query", `form[id^="${options.chiliPiperFormId}"]`);
              } else if (options.chiliPiperFormQuery) {
                args["query"] = options.chiliPiperFormQuery;
              }

              if (options.formType) {
                args["formType"] = options.formType;
              }

              new ChiliPiperMetrics(APIState.Email).start();

              window.ChiliPiper.submit(
                'iterable',
                options.chiliPiperRouter,
                args
              );
            }

            window.sessionStorage.removeItem('keepUTMs')
            resolve();
            return false;
          });

          try {
            if (formid === '1122' || formid === '1159') tob.submitMetrics(munchkinCookie, APIState.Email)
          } catch (e) {
            // Just a safety catch
          }

          if (isDevelopment()) {
            console.log("Marketo cannot be submitted from localhost. Skipping for now...");
            return setTimeout(resolve, 300);
          } else {
            form.submit();
          }
        }
      );
    });
  };

  proto.helper__addFormInputsToState = function ($form, APIState) {

    //check to make sure we have an object to add to
    if (Object.keys(APIState).length === 0 || typeof APIState !== 'object') APIState = {};

    //serialize this data into name/value
    var formData = $($form).serializeArray();

    formData.reduce((total, value) => {
      const k = value.name;
      const v = _.trim(_.first(_.split(value.value, ";")));

      // WARNING:
      // In order to avoid double runs which produce double values e.g. 
      // "email@test.com; email@test.com", we have to manually specify all array
      // fields.
      const arrayFields = [
        "Marketing_Channels__c",
        "marketoTempUseStringField5"
      ];

      if (_.includes(arrayFields, k) && _.has(total, k)) {
        total[k] += `; ${v}`;
      } else {
        total[k] = v;
      }

      return total;

    }, APIState);
  };

  proto.helper__setAllEncryptedVals = function (fieldsArray, APIState) {

    if (typeof fieldsArray === 'undefined' || typeof APIState === 'undefined') {
      return false;
    }

    fieldsArray.map((input) => {

      _LStorage.encrypted__set(`iterable/encrypted/${input}`, APIState[input]);

    });

  };

  proto.helper__getHiddenMetadata = function ($form, APIState) {

    if ($form.length === 0 || typeof APIState === 'undefined') {
      return false;
    }

    //select all the hidden fields
    let hiddenInputs = $($form).find("input[type='hidden']");
    //add hidden inputs to the values obj
    $(hiddenInputs).each(function () {
      APIState[this.name] = this.value;
    });

  };

  //returns an object from of all localstorage encrypted data, this is used for prepopulating the form
  proto.helper__getEncryptedData = function () {

    return Object.keys(localStorage)
      .filter(key => key.includes('iterable/encrypted'))
      .reduce((obj, key) => {
        var encryptedKey = key.split('/')[2];
        obj[encryptedKey] = _LStorage.decrypt__get(key);
        return obj;
      }, {});

  };

  proto.helper__toggleConsent = function( form ){

    //get form els
    const $form        = $( form );
    const $countryInput      = $form.find( '.itbl-b-select__country ' );
    const $marketingConsent  = $form.find( '.marketingConsent__wrap' );
    const $optin             = $form.find( '.itbl-c-form__privacy' );
    const gdpr = [ 'AU','CA','AL','AD','AT','AZ','BY','BE','BA','BG','HR','CY','CZ','DK','EE','FI','FR','GE','DE','GR','HU','IS','IE', 'IT','KZ','XK','LV','LI','LT','LU','MK','MT','MD','MC','ME','NL','NO','PL','PT','RO','RU','SM','RS','SK', 'SI','ES','SE','CH','TR','UA','GB','VA'];

    try{

      //add eventlistener to the country select
      $countryInput.on( 'change', function(event){

        const target = $( event.currentTarget );
        const isGdpr   = gdpr.includes( target.val() );

        if( isGdpr ){

          $marketingConsent.removeClass( 'itbl-u-hidden' );
          $optin.removeClass( 'itbl-u-hidden' );

        }else{
          $marketingConsent.addClass('itbl-u-hidden');
          $optin.addClass( 'itbl-u-hidden' );
        }
      } );
    }catch (e) {

      console.log( 'error: helper__toggleConsent', e );

    }



  };

  proto.debug = function (...msg) {

    if(location.hash === '#debug') {
      console.log(msg);
    }

  };

  /**
   *
   * Helper function that changes the state
   *
   * @param $el
   * @param property
   * @param APIState
   *
   */
  proto.setMarketoPrivacyValues = function( $el, property, APIState ){

    //check to make sure we have all arguments, and that it matches the max number of arguments
    const args  = ( [ ...arguments ].every( arg => typeof arg !== 'undefined' ) && arguments.length === 3 );
    const $target = ( $el instanceof $ ) ? $el : $($el) ;

    if ( !args ) {
      console.log('missing arguments');
      return false;
    }

    //we have to manually check for this field to be checked
    if ($target.is(':checked')) {

      APIState[property] = 'true';
      $target.val('true');

    } else {
      //if checkbox is not checked, explicitly set value to false as string, this will be converted into boolean by JSON
      APIState[property] = 'false';

    }

  };

  return proto;

}());

module.exports = FormController;
if (!('ITERABLE_MODULES' in window)) {
  window.ITERABLE_MODULES = {};
}
window.ITERABLE_MODULES.FormController = FormController;
